var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2299 11.8979C9.89079 9.33639 7.7312 7.36133 5.11766 7.36133C2.50412 7.36133 0.344531 9.33639 0.00539086 11.8979C-0.0458827 12.2851 0.275734 12.6035 0.666376 12.6035H9.56894C9.95959 12.6035 10.2812 12.2851 10.2299 11.8979Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81971 7.95166C10.7853 8.95361 11.4402 10.2614 11.6322 11.7117C11.675 12.0345 11.644 12.334 11.5569 12.603H14.1917C14.5396 12.603 14.8261 12.3194 14.7804 11.9745C14.4784 9.69285 12.5547 7.93359 10.2268 7.93359C10.0896 7.93359 9.95382 7.9397 9.81971 7.95166ZM8.20947 8.40648C9.20404 9.16438 9.92035 10.2788 10.1747 11.5632C9.92039 10.2788 9.20412 9.16435 8.20958 8.40643C8.20954 8.40644 8.20951 8.40646 8.20947 8.40648Z",
    fill: "#AFAFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08585 2.96822C8.08585 4.60752 6.75693 5.93643 5.11763 5.93643C3.47833 5.93643 2.14941 4.60752 2.14941 2.96822C2.14941 1.32892 3.47833 0 5.11763 0C6.75693 0 8.08585 1.32892 8.08585 2.96822Z",
    fill: "#AFAFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42113 5.84867C9.09324 5.07841 9.50036 4.07094 9.50036 2.96838C9.50036 2.44037 9.40699 1.93417 9.23586 1.46538C9.54188 1.3416 9.87635 1.27344 10.2267 1.27344C11.6869 1.27344 12.8706 2.45715 12.8706 3.91734C12.8706 5.37752 11.6869 6.56123 10.2267 6.56123C9.52862 6.56123 8.89371 6.29066 8.42113 5.84867ZM7.65088 4.51591C7.65088 4.5159 7.65088 4.5159 7.65088 4.5159C7.72502 4.39479 7.79072 4.26795 7.84716 4.1362C7.79072 4.26795 7.72502 4.39479 7.65088 4.51591Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsIcon);
export default __webpack_public_path__ + "static/media/students_icon.2171f61562a7543b3f634cd85359fff8.svg";
export { ForwardRef as ReactComponent };